import React, { useContext } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import Dropdown from "components/atoms/Dropdown/Dropdown";
import AnalyticsContext from "./analyticsContext";

function GraphGroupFilter() {
  const intl = useIntl();
  const { params, setFilterDateRangeBy } = useContext(AnalyticsContext);
  const options = [
    {
      label: intl.formatMessage({
        id: "report.requestDate",
        defaultMessage: "Request Date",
      }),
      value: "request_date",
    },
    {
      label: intl.formatMessage({
        id: "report.bookDate",
        defaultMessage: "Book Date",
      }),
      value: "book_date",
    },
    {
      label: intl.formatMessage({
        id: "report.pickupDate",
        defaultMessage: "Pickup Date",
      }),
      value: "pickup_date",
    },
    {
      label: intl.formatMessage({
        id: "report.deliveryDate",
        defaultMessage: "Delivery Date",
      }),
      value: "delivery_date",
    },
    {
      label: intl.formatMessage({
        id: "report.invoiceApprovedDate",
        defaultMessage: "Invoice Approved Date",
      }),
      value: "invoice_approved_date",
    },
    {
      label: intl.formatMessage({
        id: "report.invoiceSubmitDate",
        defaultMessage: "Invoice Submit Date",
      }),
      value: "invoice_submit_date",
    },
  ];

  return (
    <div className="d-flex flex-column ml-sm-2">
      <span>
        <FormattedMessage id="report.type" defaultMessage="Type" />
      </span>
      <Dropdown
        options={options}
        onChange={(item) => setFilterDateRangeBy(item.value)}
        defaultValue={options.filter((item) => item.value === params.filter_date_range_by)[0].label}
      />
    </div>
  );
}

export default GraphGroupFilter;
